(function($) {

  $(document).ready(function() {
    collection.init();
  });

  if ($(".engoj-collection-sidebar")) {
    History.Adapter.bind(window, 'statechange', function() {
      var State = History.getState();
      if (!collection.fillterClick) {
        collection.filterParams();
        var newurl = collection.filterCreateUrl();
        collection.filterGetContent(newurl);
        collection.resetFilter();
      }
      collection.fillterClick = false;
    });
  }


  var collection = {
    init: function() {

      /* Collection Filter */
      this.initCollectionFilter();

	  /* Collection Sorting */
      this.initCollectionSorting();

    },


    /* --------------------------------------------------------- */
    /* Review */
    initReview: function() {

        // return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();

    },

    /* Hide Dropdown */
    initToggle: function(){

    },

    /* --------------------------------------------------------- */
    /* Categories Fillter */

    filterCategories: function() {

    },

    fillterTagEvents: function() {

      $( "body" ).delegate( '.filter-tag a:not(".clear"), .filter-tag label', 'click',function(e) {
         $(this).toggleClass('active');
        var currentTags = [];

        if (Shopify.queryParams.constraint) {
            currentTags = Shopify.queryParams.constraint.split('+');
        } else {
            $('.engoj-collection-sidebar .filter-tag input:checked').each(function() {
                var selectedTag = $(this).val();
                if (selectedTag && currentTags.indexOf(selectedTag) === -1) {
                    currentTags.push(selectedTag);
                }
            });
        }

        if (!window.filter_mul_choice && !$(this).prev().is(":checked")) {
            var otherTag = $(this).parents('.filter-tag').find("input:checked");
            if (otherTag.length > 0) {
                var tagName = otherTag.val();
                if (tagName) {
                  var tagPos = currentTags.indexOf(tagName);
                    if (tagPos >= 0) {
                        currentTags.splice(tagPos, 1);
                    }
                }
            }
        }

        var tagName = $(this).prev().val();
        if (tagName) {
            var tagPos = currentTags.indexOf(tagName);
            if (tagPos >= 0) {
                currentTags.splice(tagPos, 1);
            } else {
                currentTags.push(tagName);
            }
        }
        if (currentTags.length) {
            Shopify.queryParams.constraint = currentTags.join('+');
        } else {
            delete Shopify.queryParams.constraint;
        }
        collection.filterAjaxClick();
        e.preventDefault();
      });
    },

    filterMapClearAll: function() {
      //clear all selection
        $("body").delegate( '.refined-widgets a.clear-all','click', function(e) {
            delete Shopify.queryParams.constraint;
            delete Shopify.queryParams.q;
            collection.filterAjaxClick();
            e.preventDefault();
          	$('.filter-tag a:not(".clear"), .filter-tag label').removeClass('active');
          	
        });

         $("body").delegate( '.filter-block .clear', 'click', function(e) {
              var currentTags = [];
              var filterTag = $(this).parent().parent();
              if (Shopify.queryParams.constraint) {
                  currentTags = Shopify.queryParams.constraint.split('+');
              }
              filterTag.find("input:checked").each(function() {
                  var selectedTag = $(this);
                  var tagName = selectedTag.val();
                  if (tagName) {
                    var tagPos = currentTags.indexOf(tagName);
                      if (tagPos >= 0) {
                        //remove tag
                          currentTags.splice(tagPos, 1);
                      }
                  }
              });
              filterTag.find("a").each(function() {
                  $(this).removeClass("active");
              });
              if (currentTags.length) {
                  Shopify.queryParams.constraint = currentTags.join('+');
              } else {
                  delete Shopify.queryParams.constraint;
              }
              collection.filterAjaxClick();
              e.preventDefault();
          });

    },

//     filterMapClear: function() {
//         $(".filter-tag").each(function() {
//           var filterTag = $(this);
//           if (filterTag.find("input:checked").length > 0) {
//               //has active tag
//               filterTag.find(".clear").show();
//           }
//         });
//     },
    
    filterMapClear: function() {
      $(".filter-tag").each(function() {
        var filterTag = $(this);
        if (filterTag.find("input:checked").length > 0) {
          //has active tag
          filterTag.find(".clear").show().click(function(e) {    
            var currentTags = [];
            if (Shopify.queryParams.constraint) {
              currentTags = Shopify.queryParams.constraint.split('+');
            }
            filterTag.find("input:checked").each(function() {
              var selectedTag = $(this);
              var tagName = selectedTag.val();
              if (tagName) {
                var tagPos = currentTags.indexOf(tagName);
                if (tagPos >= 0) {
                  //remove tag
                  currentTags.splice(tagPos, 1);
                }
              }
            });
            if (currentTags.length) {
              Shopify.queryParams.constraint = currentTags.join('+');
            } else {
              delete Shopify.queryParams.constraint;
            }
            collection.filterAjaxClick();
            e.preventDefault();
          });
        }
      });
    }, 
    

    filterParams: function() {
        Shopify.queryParams = {};
        if (location.search.length) {
            for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
                aKeyValue = aCouples[i].split('=');
                if (aKeyValue.length > 1) {
                    Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
                }
            }
        }
    },

    filterMapEvents: function() {
        collection.fillterTagEvents();
    },

    resetFilter: function() {
        $(".filter-custom .active, .filter-links .active").removeClass("active");
        $(".filter-tag input:checked").attr("checked", false);

        //category
        var cat = location.pathname.match(/\/collections\/(.*)(\?)?/);
        if (cat && cat[1]) {
          $(".filter-links a[href='" + cat[0] + "']").addClass("active");
        }
    },

    filterMapData: function(data) {

        var currentList = $(".grid-uniform");


        var productList = $(data).find(".grid-uniform");

        currentList.replaceWith(productList);

        //replace paging
        if ($(".pagination").length > 0) {
          $(".pagination").replaceWith($(data).find(".pagination"));
        };

        $('.filter-blocks').replaceWith( $(data).find(".filter-blocks") );
        collection.filterMapClear();
      	quickView();
        var ajaxCartConfig = {
          cartContainer: '.enj-minicart-ajax',
          addToCartSelector: '.enj-add-to-cart-btn',
          cartCountSelector: '.enj-cartcount',
          cartCostSelector: '.enj-cartcost',
          moneyFormat: null
        };
          jQuery(function($) {
          ajaxCart.init(ajaxCartConfig);
        });
      
        function loadmore() {
          $('.loadmore').children('a').on('click',function(e){
            $('.loadmore').addClass('d-none');
            $('.loading.tshopify-popup').addClass('active');
            var link = $('.loadmore').children('a').attr('href');
            if (link != '#' ) {
              $('.load-data').load(link+' .product-grid-view .row')

              setTimeout(function(){
                $('.load-data .js_loadmore').each(function(){$(this).appendTo('.product-grid-view .row')})
                //           $('.loadmore').appendTo('.collection_prod .product-grid-view row')
                $('.loadmore').eq(0).remove();
                loadmore();
                quickView();
                var ajaxCartConfig = {
                  cartContainer: '.enj-minicart-ajax',
                  addToCartSelector: '.enj-add-to-cart-btn',
                  cartCountSelector: '.enj-cartcount',
                  cartCostSelector: '.enj-cartcost',
                  moneyFormat: null
                };
                  jQuery(function($) {
                  ajaxCart.init(ajaxCartConfig);
                });

                $('.loading.tshopify-popup').removeClass('active');
              },2000)
            } else {
              $('.loadmore').remove();
            }
            e.preventDefault();
          })
        }
        loadmore();
      
      
        jQuery('.engoj_select_color a').each(function(){
          jQuery(this).on("click",function(){
            var engoImage = jQuery(this).data('engojvariant-img');
            jQuery(this).parents('.engoj_grid_parent').find('.engoj_find_img img').attr({ src: engoImage }); 
            return false;
          });
        });

    },

    filterCreateUrl: function(baseLink) {
      var newQuery = $.param(Shopify.queryParams).replace(/%2B/g, '+');
      if (baseLink) {

        if (newQuery != "")
          return baseLink + "?" + newQuery;
        else
          return baseLink;
      }
      return location.pathname + "?" + newQuery;
    },

    filterAjaxClick: function(baseLink) {
      delete Shopify.queryParams.page;
      var newurl = collection.filterCreateUrl(baseLink);
      collection.fillterClick = true;
      History.pushState({
        param: Shopify.queryParams
      }, newurl, newurl);
      collection.filterGetContent(newurl);
    },

    filterGetContent: function(newurl) {

      $.ajax({
        type: 'get',
        url: newurl,
        beforeSend: function() {
          showPopup('.loading');
        },

        success: function(data) {

          collection.filterMapData(data);

          collection.filterMapClear();
          hidePopup('.loading');
          hidePopup('.filter-to-left , .js-bg');
		  
        },

        error: function(xhr, text) {
          hidePopup('.loading');
          hidePopup('.filter-to-left, .js-bg');
          $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
          showPopup('.ajax-error-modal');
        }

      });
    },



    initCollectionFilter: function() {
      if ($(".engoj-collection-sidebar").length > 0) {
        collection.filterParams();
        collection.filterMapEvents();
        collection.filterMapClear();
        collection.filterMapClearAll();

      }
    },

    /* --------------------------------------------------------- */
    /* Collection Sorting */
    initCollectionSorting: function(e) {
      $(".collection-sorting a").click(function(e) {
        e.preventDefault();     
        if (!$(this).parent().hasClass("active")) {   
          Shopify.queryParams.sort_by = $(this).attr("href");
          collection.filterAjaxClick();    
          $(".collection-sorting li.active").removeClass("active");
          $(this).parent().addClass("active");
        }    
        var selected = $(this).text();   
        $(this).closest('.dropdown').find('.dropdown-label').text(selected);
        $(this).closest('.dropdown-content').removeClass('active');  

      });
    },

    /* --------------------------------------------------------- */
    /* Collection View Mode */
    initCollectionViewMode: function() {

    },


    /* --------------------------------------------------------- */
    /* Collection Show */
    initCollectionShow: function() {

    },

    /* --------------------------------------------------------- */
    /* Paging */
    initPaging: function() {

    },

  }

})(jQuery);
/* Bringners collection UX phase 2 */
(function($) {
  function selectedFilterValues() {
    var values = [];
    $('.engoj-collection-sidebar .filter-tag input:checked').each(function() {
      var value = $(this).val();
      if (value && values.indexOf(value) === -1) values.push(value);
    });
    return values;
  }

  function openFilterDrawer() {
    $('body').addClass('bringners-filter-open');
    $('#BringnersFilterDrawer').attr('aria-hidden', 'false');
    $('.bringners-control-button[aria-controls="BringnersFilterDrawer"]').attr('aria-expanded', 'true');
  }

  function closeFilterDrawer() {
    $('body').removeClass('bringners-filter-open');
    $('#BringnersFilterDrawer').attr('aria-hidden', 'true');
    $('.bringners-control-button[aria-controls="BringnersFilterDrawer"]').attr('aria-expanded', 'false');
  }

  $(document).on('click', '.bringners-control-button.js_filter', function(event) {
    event.preventDefault();
    openFilterDrawer();
  });

  $(document).on('click', '.bringners-filter-close, .bringners-filter-apply, .bringners-filter-overlay', function(event) {
    event.preventDefault();
    closeFilterDrawer();
  });

  $(document).on('keydown', function(event) {
    if (event.key === 'Escape') closeFilterDrawer();
  });

  $(document).on('click', '.bringners-filter-widget .filter-tag label', function() {
    if (!Shopify.queryParams) Shopify.queryParams = {};
    if (!Shopify.queryParams.constraint) {
      var values = selectedFilterValues();
      if (values.length) Shopify.queryParams.constraint = values.join('+');
    }
  });

  function bringnersApplyAvailabilityFilter() {
    var params = new URLSearchParams(window.location.search);
    var isActive = params.get('available') === '1';
    var $page = $('.bringners-collection-page');
    var $choices = $('.bringners-availability-choice');
    var $tiles = $('.bringners-product-tile');
    var $summary = $('.bringners-toolbar-summary span');
    var $activeFilters = $('.bringners-active-filters');
    var ensureActiveFilters = function() {
      if ($activeFilters.length) return $activeFilters;
      var $anchor = $('.bringners-collection-layout').first();
      if (!$anchor.length) return $activeFilters;
      $anchor.before('<div class="bringners-active-filters" aria-label="Aktiva filter"><span class="bringners-active-filters__label">Valda filter</span><div class="bringners-active-filters__chips"></div></div>');
      $activeFilters = $('.bringners-active-filters').first();
      return $activeFilters;
    };

    $page.toggleClass('bringners-collection-page--available-only bringners-collection-page--available-only-js', isActive);
    $choices.toggleClass('active', isActive);
    $choices.each(function() {
      var inputId = $(this).attr('for');
      if (inputId) $('#' + inputId).prop('checked', isActive);
    });

    if (isActive) {
      $tiles.filter('.is-unavailable').attr('hidden', 'hidden');
      $tiles.filter('.is-available').removeAttr('hidden');
    } else {
      $tiles.removeAttr('hidden');
    }

    var visibleCount = $tiles.filter(function() { return !$(this).attr('hidden'); }).length;
    if ($summary.length) {
      $summary.text(visibleCount + (visibleCount === 1 ? ' växt' : ' växter'));
    }

    if (isActive) {
      $activeFilters = ensureActiveFilters();
    }
    if (isActive && $activeFilters.length && !$activeFilters.find('[data-bringners-availability-chip]').length) {
      $activeFilters.find('.bringners-active-filters__chips').prepend('<a class="bringners-active-chip" data-bringners-availability-chip href="' + window.location.pathname + '"><span>I lager</span> <span aria-hidden="true">×</span></a>');
    }
    if (!isActive) {
      $activeFilters.find('[data-bringners-availability-chip]').remove();
      $activeFilters.each(function() {
        var $filters = $(this);
        if (!$filters.find('.bringners-active-chip').length) $filters.remove();
      });
    }
  }

  $(document).on('click', '.bringners-availability-choice', function(event) {
    event.preventDefault();
    var params = new URLSearchParams(window.location.search);
    if (params.get('available') === '1') {
      params.delete('available');
    } else {
      params.set('available', '1');
    }
    params.delete('page');
    var query = params.toString();
    window.history.pushState({}, '', window.location.pathname + (query ? '?' + query : ''));
    bringnersApplyAvailabilityFilter();
  });

  $(document).on('click', '[data-bringners-availability-chip]', function(event) {
    event.preventDefault();
    var params = new URLSearchParams(window.location.search);
    params.delete('available');
    params.delete('page');
    var query = params.toString();
    window.history.pushState({}, '', window.location.pathname + (query ? '?' + query : ''));
    bringnersApplyAvailabilityFilter();
  });

  bringnersApplyAvailabilityFilter();

  $(document).ajaxSuccess(function(event, xhr, settings) {
    if (!settings || !settings.url || settings.url.indexOf('/collections/') === -1) return;
    var html = xhr.responseText;
    var $html = $('<div>').append($.parseHTML(html, document, true));
    var $header = $html.find('.bringners-collection-header').first();
    var $active = $html.find('.bringners-active-filters').first();
    var $desktopFilter = $html.find('.bringners-collection-sidebar .engoj-collection-sidebar').first();
    var $drawerFilter = $html.find('.bringners-mobile-filter-drawer .engoj-collection-sidebar').first();
    var $toolbar = $html.find('.bringners-collection-toolbar').first();

    if ($header.length) $('.bringners-collection-header').first().replaceWith($header);
    if ($active.length) {
      $('.bringners-active-filters').replaceWith($active);
    } else {
      $('.bringners-active-filters').remove();
    }
    if ($desktopFilter.length) $('.bringners-collection-sidebar .engoj-collection-sidebar').first().replaceWith($desktopFilter);
    if ($drawerFilter.length) $('.bringners-mobile-filter-drawer .engoj-collection-sidebar').first().replaceWith($drawerFilter);
    if ($toolbar.length) $('.bringners-collection-toolbar').first().replaceWith($toolbar);
  });
})(jQuery);





